module.exports = require("node:diagnostics_channel");